import EventManager from '../__internals__/EventManager'
import { EventType } from '../__internals__/InternalAppSchema'
import trackEvent from './trackEvent'
import createEventType from '../__internals__/createEventType'

const trackCustomEvent =
  (eventManager: EventManager) =>
  (type: EventType, key: string, value: string, eventName?: string) => {
    trackEvent(eventManager)({
      ...createEventType(type, eventName),
      customInteraction: {
        key,
        value,
      },
    })
  }

export default trackCustomEvent
